import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/enviroments';
import { DicomInterface, EquifaxReportBD, getEquifaxReportScoring } from '../interface/dicom-interface';
import { LegacyScoring } from '../interface/legacy-scoring';

@Injectable({
  providedIn: 'root'
})
export class ScoringIngeService {

  constructor(private http: HttpClient) { }

    //Obtiene el reporte de Equifax mas reciente guardado en la BD.
    getEquifaxReportBD(request: number): Observable<any> {
      const endpoint = `${environment.apiUrl}/Equifax/${request}/getEquifaxReportBD`;
      return this.http.get<EquifaxReportBD>(endpoint);
    }

    //Obtiene el reporte de Equifax de Scoring.
    getEquifaxReportScoring(request: string): Observable<any> {
      console.log(request);
    const endpoint = `${environment.apiUrl}/Equifax/${request}/getEquifaxReport`;
      return this.http.get<getEquifaxReportScoring>(endpoint);
    }

    //Obtiene la deuda Dicom Personas de ScoringInge_Api - Equifax
    getDeudaDicom(request: String): Observable<any> {
      const endpoint = `${environment.apiUrl}/Equifax/${request}/getEquifaxReport`;
      return this.http.get<number>(endpoint);
    }

    //Obtiene la deuda Dicom Personas desde la BD
    getDeudaDicomBD(request: number): Observable<any> {
      const endpoint = `${environment.apiUrl}/Equifax/${request}/obtenerDatosDicom`;
      return this.http.get<DicomInterface>(endpoint);
    }

    getLegacyData(request: string): Observable<any> {
      const endpoint = `${environment.apiUrl}/Equifax/${request}/GetLegacyAdmin`;
      return this.http.get<LegacyScoring>(endpoint);
    }

}
